<div class="kiosk-shell" mat-dialog-content>
  <div class="hero">
    <div class="eyebrow">Self check-in</div>
    <h1 class="header">Repair Lab Kiosk</h1>
    <p class="lede">Choose the best starting point so we can get your repair moving.</p>
  </div>

  <div *ngIf="panel == 'home'" class="panel panel-home">
    <div class="active-jobs">
      <div class="jobs-header">
        <div class="eyebrow muted">Active tasks</div>
        <div class="job-count">
          {{ activeTaskCount }} running
        </div>
      </div>
      <div class="job-log" *ngIf="activeTaskCount === 0">Task queue is clear.</div>
    </div>

    <div class="option-grid">
      <button class="option-card new" (click)="switchPanel('new-customer')" matRipple>
        <span class="icon-pill">N</span>
        <span class="copy">
          <span class="label">New customer</span>
          <span class="hint">Begin a fresh repair request</span>
        </span>
        <span class="chevron">&gt;</span>
      </button>

      <button class="option-card existing" (click)="switchPanel('existing-customer')" matRipple>
        <span class="icon-pill">E</span>
        <span class="copy">
          <span class="label">Existing customer</span>
          <span class="hint">Look up a current ticket</span>
        </span>
        <span class="chevron">&gt;</span>
      </button>
    </div>

    <div class="helper-text">Need help? Head back to the counter and we will jump in.</div>
  </div>

  <div *ngIf="panel == 'new-customer'" class="panel panel-form">
    <div class="panel-top">
      <button class="back-button" (click)="goBack()" matRipple>&larr; Back</button>
      <div class="eyebrow muted">New customer</div>
    </div>
    <h3 class="panel-title">Tell us a bit about you</h3>
    <div class="input-group">
      <input autocomplete="off" placeholder="Full name" [(ngModel)]="newCustomer.name" (ngModelChange)="scheduleSave()">
      <input autocomplete="off" placeholder="Phone number" [(ngModel)]="newCustomer.phone" (ngModelChange)="scheduleSave()">
      <input autocomplete="off" placeholder="Email address (optional)" [(ngModel)]="newCustomer.email" (ngModelChange)="scheduleSave()">

      <button class="next-button" (click)="switchPanel('pick-job')">Next</button>
    </div>
  </div>

  <div *ngIf="panel == 'existing-customer'" class="panel panel-form">
    <div class="panel-top">
      <button class="back-button" (click)="goBack()" matRipple>&larr; Back</button>
      <div class="eyebrow muted">Existing customer</div>
    </div>
    <h3 class="panel-title">Find your repair</h3>
    <div class="input-group">
      <input autocomplete="off" class="customerSearch" placeholder="Search by name, phone, or ticket #" [(ngModel)]="existingSearch" (ngModelChange)="scheduleSave()">

      <button class="next-button" (click)="switchPanel('pick-job')">Next</button>
    </div>
  </div>

  <div *ngIf="panel == 'pick-job'" class="panel panel-tiles">
    <div class="panel-top">
      <button class="back-button" (click)="goBack()" matRipple>&larr; Back</button>
      <div class="eyebrow muted">Step 2</div>
    </div>
    <h3 class="panel-title">What are we working on?</h3>
    <div class="tile-grid">
      <button type="button" class="tile-btn" (click)="openLaptopForm()" matRipple>Laptop</button>
      <button type="button" class="tile-btn" (click)="openConsoleForm()" matRipple>Console</button>
      <button type="button" class="tile-btn" (click)="openDataRecoveryForm()" matRipple>Data recovery</button>
      <button type="button" class="tile-btn" (click)="openOtherForm()" matRipple>Other</button>
    </div>
  </div>

  <div *ngIf="panel == 'laptop'" class="panel panel-form panel-device">
    <div class="panel-top">
      <button class="back-button" (click)="goBack()" matRipple>&larr; Back</button>
      <div class="eyebrow muted">Laptop repair</div>
    </div>
    <h3 class="panel-title">Laptop details</h3>
    <div class="input-group">
      <label class="field-label">Laptop model number</label>
      <input
        autocomplete="off"
        placeholder="Enter the model number"
        [(ngModel)]="laptopModelNumber"
        (ngModelChange)="scheduleSave()"
      >

      <label class="field-label">Issue</label>
      <textarea
        rows="4"
        placeholder="Describe the problem (e.g. not turning on, cracked screen, liquid damage)"
        [(ngModel)]="laptopIssue"
        (ngModelChange)="scheduleSave()"
      ></textarea>

      <button class="next-button" type="button" (click)="switchPanel('pick-job')">Next</button>
    </div>
  </div>

  <div *ngIf="panel == 'console'" class="panel panel-form panel-console">
    <div class="panel-top">
      <button class="back-button" (click)="goBack()" matRipple>&larr; Back</button>
      <div class="eyebrow muted">Console repair</div>
    </div>
    <h3 class="panel-title">Console details</h3>
    <div class="input-group">
      <label class="field-label">Console type</label>
      <div class="pill-row">
        <button
          type="button"
          class="pill-chip"
          *ngFor="let type of consoleTypes"
          [class.active]="selectedConsoleType === type"
          (click)="selectedConsoleType = type; scheduleSave()"
          matRipple
        >
          {{ type }}
        </button>
      </div>

      <label class="field-label">Issue</label>
      <textarea
        rows="4"
        placeholder="Describe the problem (e.g. HDMI port damage, not turning on)"
        [(ngModel)]="consoleIssue"
        (ngModelChange)="scheduleSave()"
      ></textarea>

      <button class="next-button" type="button" (click)="switchPanel('pick-job')">Next</button>
    </div>
  </div>

  <div *ngIf="panel == 'data-recovery'" class="panel panel-form panel-device">
    <div class="panel-top">
      <button class="back-button" (click)="goBack()" matRipple>&larr; Back</button>
      <div class="eyebrow muted">Data recovery</div>
    </div>
    <h3 class="panel-title">Recovery details</h3>
    <div class="input-group">
      <label class="field-label">Device type</label>
      <div class="pill-row">
        <button
          type="button"
          class="pill-chip"
          *ngFor="let type of dataRecoveryTypes"
          [class.active]="selectedDataRecoveryType === type"
          (click)="selectedDataRecoveryType = type; scheduleSave()"
          matRipple
        >
          {{ type }}
        </button>
      </div>

      <label class="field-label">Files to recover</label>
      <textarea
        rows="4"
        placeholder="Tell us what files matter most (e.g. photos, documents, business files)"
        [(ngModel)]="dataRecoveryFiles"
        (ngModelChange)="scheduleSave()"
      ></textarea>

      <button class="next-button" type="button" (click)="switchPanel('pick-job')">Next</button>
    </div>
  </div>

  <div *ngIf="panel == 'other'" class="panel panel-form panel-device">
    <div class="panel-top">
      <button class="back-button" (click)="goBack()" matRipple>&larr; Back</button>
      <div class="eyebrow muted">Other repair</div>
    </div>
    <h3 class="panel-title">Repair details</h3>
    <div class="input-group">
      <label class="field-label">Issue</label>
      <textarea
        rows="4"
        placeholder="Describe the issue"
        [(ngModel)]="otherIssue"
        (ngModelChange)="scheduleSave()"
      ></textarea>

      <button class="next-button" type="button" (click)="switchPanel('pick-job')">Next</button>
    </div>
  </div>
</div>
